import React, { Component } from 'react';
import CarouselSlider from '../common/CarouselSlider';
import LoginHeader from '../common/LoginHeader';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import AlertDismissable from '../common/AlertDismissable';
import CustomScroll from 'react-custom-scroll';
import { validationMessage, appBasePath, imageBasePath } from '../../constants/staticData';
import { has } from 'lodash';

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submissionError: false,
      isButtonLoading: false
    };
    this.initialFormData = {
      'email': ''
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      'email': false
    };
    this.onFieldBlur = this.onFieldBlur.bind(this);
    this.forgotPasswordAction = this.forgotPasswordAction.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.authReducer.hideButtonLoader && this.state.isButtonLoading) {
      this.setState({ 'isButtonLoading' : false});
    }
    if (nextProps.authReducer.currentComponentKey) {
      this.props.router.push(appBasePath + nextProps.authReducer.currentComponentKey);
      this.props.actions.clearComponentKey();
    }
  }
  onFieldBlur(value, name, validateError) {
    this.formData[name] = value;
    if (has(this.errors, name)) {
      this.errors[name] = validateError;
    }
  }
  forgotPasswordAction(e) {
    e.preventDefault();
    if (this.formData.email && this.errors['email'] != true) {
      this.setState({'isButtonLoading': true});
      this.props.actions.forgotPassword(this.formData.email);
    } else {
      this.errors['email'] = true;
      this.setState({ 'submissionError': true })
    }
  }
  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }
  render() {
    const { router, authReducer } = this.props;
    return (
      <div className="container-fluid" id="wrapper">
        <LoginHeader headerTitle="Sign Up" />
        <CarouselSlider pageType="signIn" sliderImage={`${imageBasePath}/images/customer-log-in-carcility.png`}/>
        <div className="col-md-6 col-sm-12 col-xs-12 pad0 grid-12">
          <div className="customScroll">
            <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
              <div className="login-panel otp">
                <div className="login-panel-header forget-panel-header">
                  <h3 className="login-title">Forgot Password ?</h3>
                  <p className="note-text">
                    Enter your email address to recieve password reset link.
                        </p>
                </div>
                <div className="login-panel-body forget-input">
                  {authReducer && authReducer.showErrorMessage && <AlertDismissable bsStyle="danger" closeLabel="Close alert" closeAction={this.props.actions.hideErrorMessage}>
                    <p> <i className="mdi mdi-block-helper" /> {authReducer.statusMessage} </p>
                  </AlertDismissable>}
                  <TextInput
                    customClass="otp-input"
                    label="Email"
                    name="email"
                    type="email"
                    showValidationError={this.errors['email']}
                    emptyError={validationMessage.email.emptyError}
                    validationError={validationMessage.email.validationError}
                    onBlur={this.onFieldBlur.bind(this)}
                    />
                  <Button data-labelledby="Email Link" btnCallBack={this.forgotPasswordAction} btnType="red" btnSize="sm" fontSize={14} label="Email Link" isButtonLoading={this.state.isButtonLoading}/>
                </div>
              </div>
            </CustomScroll>
          </div>
        </div>
      </div>
    );
  }
}
